import { CurrencyEnum } from '@systemeio/types'

export const PRICE_PLANS_API = '/api/dashboard/customer/price-plans'

export const getPricePlansPriceRestrictionsApiPath = (currency: CurrencyEnum) => {
  return `/api/dashboard/customer/price-plan/price-restrictions/${currency}`
}
